let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5MkOT")).then(() => parcelRequire('29qD5'));